import React from "react";
import "./AppleTvClone.css";
import PosterCard from "./components/PosterCard";

// Suspense fallback for the code-split /apple routes. Renders the same chrome
// (side-nav stripe, hero shell, shelf strip) so the chunk-load window does
// not flash. Variants reserve the right amount of vertical space for each
// destination so layout doesn't shift when the real route mounts.

const HOME_SHELF_PLACEHOLDERS = ["movies", "tv", "theaters", "streaming", "oscar", "prestige"];
const HOME_SHELF_TILE_COUNT = 8;

function HeroSkeleton({ compact = false }) {
  return (
    <section className={`apple-clone__hero ${compact ? "apple-clone__hero--compact" : ""}`} aria-hidden="true">
      <div className="apple-clone__hero-media-shell">
        <div className="apple-skeleton" style={{ position: "absolute", inset: 0, borderRadius: 26 }} />
      </div>
      <section className="apple-clone__detail-summary-rail apple-clone__hero-summary-rail">
        <div className="apple-clone__detail-compact-overlay apple-clone__hero-compact-overlay">
          <div className="apple-skeleton apple-skeleton--text" style={{ width: "30%", height: 12 }} />
          <div style={{ height: 8 }} />
          <div className="apple-skeleton apple-skeleton--text" style={{ width: "60%", height: 18 }} />
          <div style={{ height: 8 }} />
          <div className="apple-skeleton apple-skeleton--text" style={{ width: "40%", height: 10 }} />
        </div>
      </section>
    </section>
  );
}

function ShelfSkeleton({ rowKey = "row", count = HOME_SHELF_TILE_COUNT }) {
  return (
    <section className="apple-clone__rail is-loading" aria-hidden="true">
      <h2>
        <span className="apple-skeleton apple-skeleton--text" style={{ display: "inline-block", width: 180, height: 16 }} />
      </h2>
      <div className="apple-clone__track">
        {Array.from({ length: count }).map((_, idx) => (
          <PosterCard key={`${rowKey}-${idx}`} state="skeleton" />
        ))}
      </div>
    </section>
  );
}

export default function AppleRouteFallback({ variant = "home" }) {
  const includeHero = variant === "home" || variant === "detail" || variant === "person" || variant === "cast" || variant === "account";
  const shelfCount = variant === "home" ? HOME_SHELF_PLACEHOLDERS.length
    : variant === "library" ? 4
    : variant === "search" ? 0
    : variant === "list" ? 1
    : 2;

  return (
    <div className={`apple-clone apple-clone--${variant === "home" ? "home" : variant} apple-clone--fallback`}>
      {includeHero ? <HeroSkeleton compact={variant !== "home" && variant !== "detail"} /> : null}
      {shelfCount > 0 ? (
        <div className="apple-clone__rails">
          {Array.from({ length: shelfCount }).map((_, idx) => (
            <ShelfSkeleton
              key={`${variant}-shelf-${idx}`}
              rowKey={HOME_SHELF_PLACEHOLDERS[idx] || `r${idx}`}
            />
          ))}
        </div>
      ) : (
        <div className="apple-clone__rails">
          <div className="apple-skeleton apple-skeleton--text" style={{ width: "30%", height: 14, margin: "20px auto 8px" }} />
          <div className="apple-skeleton" style={{ width: "100%", height: 220, borderRadius: 18 }} />
        </div>
      )}
    </div>
  );
}
